import { render, staticRenderFns } from "./workflow_canvas_brick.vue?vue&type=template&id=7352ce83&scoped=true&"
import script from "./workflow_canvas_brick.vue?vue&type=script&lang=js&"
export * from "./workflow_canvas_brick.vue?vue&type=script&lang=js&"
import style0 from "./workflow_canvas_brick.vue?vue&type=style&index=0&id=7352ce83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352ce83",
  null
  
)

export default component.exports